import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';
import VersionMessage from '@bibliocommons/version-message';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import FeatureTogglz from '@bibliocommons/feature-togglz';
import { TOGGLZ_FEATURES } from '@bibliocommons/constants-feature-togglz';

import FeedbackContainer from 'app/components/deprecated/feedback/FeedbackContainer';
import Footer from '../../Footer';

/** @extends React.Component */
export default class DeprecatedFooter extends BcReactComponent {
  renderDeprecated() {
    const { cmsEnabled } = this.props;
    const className = cn('cp-deprecated-footer', { 'cms-footer': cmsEnabled, container: !cmsEnabled });
    return (
      <div className={className}>
        <FeedbackContainer />
        {/* eslint-disable react/no-danger */}
        <div className="cp-footer-content" dangerouslySetInnerHTML={{ __html: this.props.footer }} />
        {/* eslint-enable */}
        <VersionMessage version={this.props.appVersion} />
      </div>
    );
  }

  renderEnhanced() {
    return <Footer {...this.props} />;
  }

  render() {
    return (
      <FeatureTogglz>
        {features =>
          features.get(TOGGLZ_FEATURES.NERF_GLOBAL_UI_UPDATES) ? this.renderEnhanced() : this.renderDeprecated()
        }
      </FeatureTogglz>
    );
  }
}

DeprecatedFooter.propTypes = {
  appVersion: PropTypes.string.isRequired,
  cmsEnabled: PropTypes.bool,
  footer: PropTypes.string.isRequired
};
